import { useEffect, useRef, useState } from "react";
import {
  Box,
  Flex,
  forwardRef,
  Heading,
  Link,
  Spacer,
} from "@chakra-ui/react";
import ptBR from "date-fns/locale/pt-BR";
import DatePicker, { registerLocale } from "react-datepicker";
import { format, sub, addDays } from "date-fns";
import { WithAuth } from "@/hoc";
import { useRedeem } from "@/hooks/useRedeem";
import { RedeemHistory } from "@/layouts";
import { CalendarIcon } from "@/styles/icons/CalendarIcon";
import { ArrowDownIcon } from "@/styles/icons/ArrowDownIcon";
import { Pagination } from "@/components";
import NewTransfer from "@/components/NewTransferModal";
import TransferList from "@/components/TransferListModal";
import { SaldoComponentAntecipation } from "./_SaldoComponentAntecipation";
import "react-datepicker/dist/react-datepicker.css";
import "./_datePicker.css";
import { useNavigate } from "react-router-dom";
import { Button, Loading, PageHeading } from "barte-design-system";
import { Tabs } from "@/components";

const Resgates = () => {
  registerLocale("ptBR", ptBR);
  const { initialData, getInitialData, getReedemAmount, isLoading, getBalanceInitialData } = useRedeem();
  const [startDate, setStartDate] = useState<Date>(sub(new Date(), { days: 30 }));
  const [endDate, setEndDate] = useState<Date>(new Date());
  const navigate = useNavigate();
  const [startOldDate, setStartOldDate] = useState<Date>(sub(new Date(), { days: 30 }));
  const [endOldDate, setEndOldDate] = useState<Date>(new Date());
  const [isDatePickerOpen, setIsDatePickerOpen] = useState(false);
  const [currentPage, setCurrentPage] = useState(0);
  const [pageSize, setPageSize] = useState(10);
  const [updatedRedeens, setUpdatedRedeens] = useState<number>(0);
  const [openModal, setOpenModal] = useState<boolean>(false);
  const [openModalList, setOpenModalList] = useState<boolean>(false);
  const [tabStatus, setTabStatus] = useState<string>("REDEEMS");
  const featureToggle = JSON.parse(localStorage.getItem("barte-features-list-user"));
  const user = JSON.parse(localStorage.getItem("barte-user-info"));
  const tabs = [
    {
      tab: "Extrato",
      key: "REDEEMS",
      status: "REDEEMS",
      content: <></>
    },
    {
      tab: "Lançamentos futuros",
      key: "FUTURE_REDEEMS",
      status: "FUTURE_REDEEMS",
      content: <></>
    },
    ...(initialData?.isOnDemandEnabled === true ? [{
      tab: "Antecipações",
      key: "ANTECIPATION",
      status: "ANTECIPATION",
      content: <></>
    }] : [])
  ];
  const viewButtonTransfer = featureToggle?.includes("view_seller_transfer");
  const CustomInput = forwardRef(({ value }: any, ref) => (
    <Button
      ref={ref}
      onClick={() => setIsDatePickerOpen(true)}
      variant="outline"
      size="sm"
      iconLeft={<CalendarIcon size={16} />}
      iconRight={<ArrowDownIcon color="#3D485C" />}
    >
      {value}
    </Button>
  ));

  const onDateChange = (dates: any) => {
    const [start, end] = dates;
    setStartDate(start);
    setEndDate(end);
    if (start && end) return setIsDatePickerOpen(false);
  };

  const onTabChange = (activeKey) => {
    setCurrentPage(0)
    if (activeKey === "FUTURE_REDEEMS") {
      setTabStatus(activeKey)
      const initialDate = addDays(new Date(), 1);
      const finalDate = addDays(initialDate, 60);
      setStartDate(initialDate);
      setEndDate(finalDate);

    }
    if (activeKey === "REDEEMS") {
      setTabStatus(activeKey)
      const initialDate = sub(new Date(), { days: 30 });
      const finalDate = new Date();
      setStartDate(initialDate);
      setEndDate(finalDate);
    }
    if (activeKey === "ANTECIPATION") {
      setTabStatus(activeKey)
      const initialDate = addDays(new Date(), 1);
      const finalDate = addDays(initialDate, 360);
      setStartDate(initialDate);
      setEndDate(finalDate);
    }
  }

  useEffect(() => {
    if (isDatePickerOpen === false && (endDate !== endOldDate || startDate !== startOldDate)) {
      try {
        getInitialData(
          {
            executionDateInitial: format(startDate, "yyyy-MM-dd"),
            executionDateFinal: format(endDate, "yyyy-MM-dd"),
            sort: "executionDate,desc",
            statementType: tabStatus === "ANTECIPATION" ? "CREDIT_ANTICIPATED" : "All",

          },
          {
            size: pageSize,
            page: currentPage,
          }
        );
        if (user?.bankingType?.includes("BARTE_BANKING")) {
          getBalanceInitialData();
        }
        getReedemAmount()
      } catch (error) {
        return error
      } finally {
        setEndOldDate(endDate)
        setStartOldDate(startDate)
      }

    }
  }, [isDatePickerOpen, currentPage, pageSize, openModal, openModalList, tabStatus, updatedRedeens]);

  useEffect(() => {

    try {
      getInitialData(
        {
          executionDateInitial: format(startDate, "yyyy-MM-dd"),
          executionDateFinal: format(endDate, "yyyy-MM-dd"),
          sort: "executionDate,desc",
          statementType: tabStatus === "ANTECIPATION" ? "CREDIT_ANTICIPATED" : "All",

        },
        {
          size: pageSize,
          page: currentPage,
        }
      );

      getReedemAmount()
    } catch (error) {
      return error
    } finally {
      setEndOldDate(endDate)
      setStartOldDate(startDate)
    }


  }, [currentPage, pageSize, openModal, openModalList, tabStatus, updatedRedeens]);

  useEffect(() => {
    const totalItems = initialData?.totalElements || 0;
    const newTotalPages = totalItems > 0 ? Math.max(1, Math.ceil(totalItems / pageSize)) : 1;
    
    if (currentPage >= newTotalPages && newTotalPages > 0) {
      setCurrentPage(newTotalPages - 1);
    }
  }, [pageSize, initialData?.totalElements]);



  return (
    <>
      {
        initialData && Object.keys(initialData).length > 0 ? (

          <>
            <NewTransfer isOpen={openModal} onClose={() => setOpenModal(false)} data={initialData} />
            {openModalList && <TransferList open={setOpenModalList} />}
            <Flex w="100%" direction="column" gap="20px">
              <PageHeading title="Financeiro" />
              {featureToggle?.includes("view_seller_balance") &&
               viewButtonTransfer && (
                  <SaldoComponentAntecipation
                    openTransferList={setOpenModalList}
                    open={setOpenModal}
                    data={initialData}
                    setUpdatedRedeens={setUpdatedRedeens}
                    updatedRedeens={updatedRedeens}
                  />
                )}

              <Flex minW="100%" direction="column" gap="24px" mt="20px">

                <Flex align="center" gap="16px" w="100%">
                  <Box flex="1" minW="0">
                    <Tabs tabs={tabs.map(({ key, tab, content }) => ({
                      key: key,
                      label: tab,
                      content: content
                    }))} onChange={setTabStatus} currentKey={tabStatus} />
                  </Box>

                  <Box flexShrink={0}>
                    <DatePicker
                      locale="ptBR"
                      selected={startDate}
                      onChange={(date) => onDateChange(date)}
                      startDate={startDate}
                      endDate={endDate}
                      onInputClick={() => setIsDatePickerOpen(true)}
                      onClickOutside={() => {
                        if (endDate) return setIsDatePickerOpen(false);
                      }}
                      open={isDatePickerOpen}
                      customInput={<CustomInput />}
                      wrapperClassName="fin-dp"
                      calendarClassName="fin-dp-cal"
                      popperClassName="fin-dp-pop"
                      popperPlacement="bottom-end"
                      selectsRange
                      dateFormat="dd/MM/yyyy"
                      minDate={tabStatus === 'FUTURE_REDEEMS' ? sub(new Date(), { days: 1 }) : sub(new Date(), { days: 360 })}
                      maxDate={addDays(new Date(), 360)}
                    />
                  </Box>
                </Flex>
                {tabStatus === "REDEEMS" && (
                  <RedeemHistory 
                    redeems={initialData?.content} 
                    isLoading={isLoading}
                    currentPage={currentPage}
                    totalPages={initialData?.totalPages}
                    totalItems={initialData?.totalElements}
                    pageSize={pageSize}
                    onPageSizeChange={(size) => setPageSize(size)}
                    onPageChange={(page) => setCurrentPage(page - 1)}
                  />
                )}
                {tabStatus === "FUTURE_REDEEMS" && (
                  <RedeemHistory 
                    redeems={initialData?.content} 
                    isLoading={isLoading}
                    currentPage={currentPage}
                    totalPages={initialData?.totalPages}
                    totalItems={initialData?.totalElements}
                    pageSize={pageSize}
                    onPageSizeChange={(size) => setPageSize(size)}
                    onPageChange={(page) => setCurrentPage(page - 1)}
                  />
                )}

                {tabStatus === "ANTECIPATION" && initialData.isOnDemandEnabled === true && (
                  <RedeemHistory 
                    redeems={initialData?.content} 
                    isLoading={isLoading}
                    currentPage={currentPage}
                    totalPages={initialData?.totalPages}
                    totalItems={initialData?.totalElements}
                    pageSize={pageSize}
                    onPageSizeChange={(size) => setPageSize(size)}
                    onPageChange={(page) => setCurrentPage(page - 1)}
                  />
                )}
              </Flex>
            </Flex>
          </>

        ) : isLoading && (
          <Flex align="center" alignContent="center" w="100%" h="100%" justify="center" gap="2">
            <Loading type="page" description="Carregando" />
          </Flex>
        )
      }

    </>
  );
};

export default WithAuth(Resgates);